import React, { useState, cloneElement } from "react";
import {
    List,
    Datagrid,
    TextField,
    Filter,
    TextInput,
    useRecordContext,
    Pagination,
    SelectInput,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import Swal from "sweetalert2";

const PlantsListFilter = (props) => (
  <Filter {...props}>
    <TextInput source="plant_name" />
    <TextInput source="plant_code" />
    <SelectInput
      label="Rocks Active"
      source="enabled"
      choices={[
        { id: true, name: "ON" },
        { id: false, name: "OFF" },
      ]}
    />
  </Filter>
);

const SettingChangeToggle = () => {
    const record = useRecordContext();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    const recordValue = record?.enabled ? 'ON' : 'OFF';

    const handleTogglePress = (event) => {
        const url = `${apiUrl}/rocks_plants/${record.id}`;
        const data = {
            enabled: event.target.checked,
        }
        const options = CommonHeaderOption()
        options.method = "PATCH";
        options.body = JSON.stringify(data);

        Swal.fire({
            text: 'Please wait while your request is being processed.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        fetch(url, options)
            .then(res => {
                if (res.status === 401) {
                    localStorage.removeItem("__state");
                    window.location.href = "#/login";
                }
                return res.json();
            })
            .then(json => {
                console.log('json ===>', json);
                window.location.reload();
            }).catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Unable to process your request at this time. Please try again later.',
                })
                console.log(error);
            });
    }

    return (
        <div>
            <div className={`toggle-button-container ${recordValue === 'ON' ? 'toggle-button-on' : ''}`}>
                <label className="switch"><input type="checkbox" checked={recordValue === 'ON'} onChange={handleTogglePress} />    <div></div>
                </label>
                <span className="switch-status">{recordValue}</span>
            </div>
        </div>
    )
}

const PlantsPagination = (props) => (
    <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);

const RocksPlantsList = () => {
    return (
        <React.Fragment>
            <Scrollbars class="scroll-container" >
                <List
                    filters={<PlantsListFilter />}
                    pagination={<PlantsPagination />}
                    sort={{ field: 'created_at', order: 'DESC' }}
                    title="Aggregate Plant List"
                    resource="rocks_plants"
                    exporter={false}
                >
                    <Datagrid bulkActionButtons={false}>
                        <TextField source="plant_name" label="Name" />
                        <TextField source="plant_code" />
                        <SettingChangeToggle source="sett_value" label="Rocks Active" />
                    </Datagrid>
                </List>
            </Scrollbars>
        </React.Fragment>
    )
};

export default RocksPlantsList;
